module.exports = __webpack_public_path__ + "media/images/icons/x-2519526b05fd17f2abcee43237773250.svg";